import React from "react";
import { UncontrolledTooltip } from "reactstrap";
import classes from "./partlist.module.scss";
import { API_HOST } from "src/utils/constants";
import { useSortable } from "@dnd-kit/sortable";
import { PartWithThumbnail } from "../domain/CourseEditModel";
import { CSS } from "@dnd-kit/utilities";
import { useAtom } from "jotai";
import { isAnyPartDraggingAtom } from "./EditThemeParts";
import { useI18n } from "src/utils/lni18n";

export interface PartProps {
    part: PartWithThumbnail;
    dragged?: boolean;
    onContextMenu: React.MouseEventHandler<HTMLElement>;
    dummy?: boolean;
}


export const PartSmall: React.FC<PartProps> = ({ part, dragged, onContextMenu, dummy }) => {


    const {
        attributes,
        listeners,
        setNodeRef,
        transform,
        transition,
    } = useSortable({ id: part.Id });

    const style = {
        transform: CSS.Transform.toString(transform),
        transition,
        opacity: dragged ? "75%" : ""
    };


    /**
     *  if this is true - there's a drag doing on somewhere. Just switch of all Tooltips.
     */
    const [aPartIsDragging] = useAtom(isAnyPartDraggingAtom);
    const { languageService: t } = useI18n();


    /**
     * A marker just to show where a drop would be fitted 
     */
    if (part.Id === "mark") return <div className={`${classes.marker}`} ></div>

     /**
      * dummy === true means this is just a placeholder when the theme is empty of parts.
      * show this "part" as a target to drag new parts into the theme.
      */
    if (dummy) {
        return <div ref={setNodeRef} className={`${classes.dummy}`} id="dummy"  ><div>{t.getText("empty")}</div></div>
    }


    return (

        <div  style={style} ref={setNodeRef} id={"l_" + part.Id} className={`hand m-3 ${classes.partListing} ${classes.smallPart} ${dragged && classes.dragged}`} {...attributes} {...listeners} >
            <div onContextMenu={onContextMenu} className={`card-box card ${classes['part-listing-card']}`} >

                <div className={"text-center " + classes['card-image']}>
                    {part.ImageUrl ?
                        <img draggable={false} src={API_HOST + part.ImageUrl} alt={part.Name} />
                        : <div className={classes.imageDummy + " w-100 h-100"}>&nbsp;</div>
                    }

                </div>
                <div className="overflow-hidden p-2">
                    {part.Name}
                </div>
            </div>

            {/* hide tooltip if there is a drag operation going on */}
            {!aPartIsDragging &&
                <UncontrolledTooltip placement="auto-start" autohide={false} target={'l_' + part.Id} trigger={'hover'}
                    delay={{ show: 300, hide: 0 }}>
                    <strong>{part.Name}</strong>
                </UncontrolledTooltip>
            }
        </div>
    );

};